import { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import { LOCATIONS, VIDEO_TYPES, type LocationSlug } from "./lib/site";

const VideoGrowthEngine = lazy(() => import("./pages/VideoGrowthEngine"));
const CommercialVideo = lazy(() => import("./pages/CommercialVideo"));
const OurWork = lazy(() => import("./pages/OurWork"));
const OtherServices = lazy(() => import("./pages/OtherServices"));
const AboutPage = lazy(() => import("./pages/AboutPage"));
const VideoTypePage = lazy(() => import("./pages/VideoTypePage"));
const LocationPage = lazy(() => import("./pages/LocationPage"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));
const CookiePolicy = lazy(() => import("./pages/CookiePolicy"));
const TermsAndConditions = lazy(() => import("./pages/TermsAndConditions"));
const AccessibilityStatement = lazy(() => import("./pages/AccessibilityStatement"));
const ThankYou = lazy(() => import("./pages/ThankYou"));
const Watch = lazy(() => import("./pages/Watch"));
const NotFound = lazy(() => import("./pages/NotFound"));
const CookieConsent = lazy(() => import("./components/CookieConsent"));

const App = () => (
  <HelmetProvider>
    <BrowserRouter>
      <ScrollToTop />
      <Suspense fallback={<div className="min-h-screen" />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/video-growth-engine" element={<VideoGrowthEngine />} />
          <Route path="/commercial-video" element={<CommercialVideo />} />
          <Route path="/our-results" element={<OurWork />} />
          <Route path="/other-services" element={<OtherServices />} />
          <Route path="/about" element={<AboutPage />} />
          {VIDEO_TYPES.map((v) => <Route key={v.slug} path={`/${v.slug}`} element={<VideoTypePage slug={v.slug} />} />)}
          {(Object.keys(LOCATIONS) as LocationSlug[]).map((s) => <Route key={s} path={`/${s}`} element={<LocationPage slug={s} />} />)}
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/terms" element={<TermsAndConditions />} />
          <Route path="/accessibility-statement" element={<AccessibilityStatement />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="/watch" element={<Watch />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <CookieConsent />
      </Suspense>
    </BrowserRouter>
  </HelmetProvider>
);

export default App;
